import { AnyAction, ActionCreator } from 'redux';
import { ActionStateType } from '.';

interface InProgressAction extends AnyAction {
    type: ActionStateType.InProgress;
}

export const inProgress: ActionCreator<InProgressAction> = () => {
    return {
        type: ActionStateType.InProgress
    };
};

interface SuccessAction extends AnyAction {
    type: ActionStateType.Success;
}

export const success: ActionCreator<SuccessAction> = () => {
    return {
        type: ActionStateType.Success
    };
};

interface FailAction extends AnyAction {
    type: ActionStateType.Fail;
}

export const fail: ActionCreator<FailAction> = () => {
    return {
        type: ActionStateType.Fail
    };
};

export type StateAction =
    | InProgressAction
    | SuccessAction
    | FailAction;



// WEBPACK FOOTER //
// ./src/actions/stateActions.ts